








import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TextLabel extends Vue {
  @Prop({
    type: [Boolean, Object],
    default: () => {
      return {
        border: "#616161",
        content: "#ffffff"
      };
    }
  })
  color!: boolean | any;

  @Prop({ type: Boolean, default: false }) reverse!: boolean;
  @Prop({
    type: Object,
    default: () => {
      return {};
    }
  })
  customStyle!: any;
  labelElementStyle = {};

  async created() {
    const reverse = this.reverse;
    const color = this.color;
    const customStyle = this.customStyle;

    const borderColor = color.border;
    const contentColor = color.content;

    const backgroundColor = this.initStyle(contentColor, borderColor);
    const textColor = this.initStyle(borderColor, contentColor);

    const labelElementStyle = {
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      color: textColor
    };

    this.labelElementStyle = Object.assign(customStyle, labelElementStyle);
  }

  initStyle(defaultStyle: any, reverseStyle: any) {
    const reverse = this.reverse;
    return reverse ? reverseStyle : defaultStyle;
  }
}
